import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../context/AuthContext';

export default function AppLayout() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  const isAthlete = user.role === 'player';
  return (
    <div className="min-h-screen flex bg-white rink-pattern">
      {!isAthlete && <Sidebar />}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
